'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { warmPrForOpen } from '@/lib/desktop-pr-warm-up';
import { useRealtime } from '@/lib/hooks/use-realtime';
import { getInternalNotificationPath } from '@/lib/notifications/web-app/notification-path';
import { REALTIME_KEYS } from '@/lib/realtime/types';
import { useAuth } from '@/providers/auth-provider';

/**
 * Loads the PR a desktop notification is about when the notification arrives, so a click on it
 * opens a PR that is already loaded.
 */
export function DesktopNotificationWarmUp() {
  const $ = _c(8);
  const queryClient = useQueryClient();
  const router = useRouter();
  const {
    user
  } = useAuth();
  const t0 = user?.id ?? "";
  const t1 = Boolean(user?.id);
  let t2;
  if ($[0] !== queryClient || $[1] !== router || $[2] !== user) {
    t2 = event => {
      const path = getInternalNotificationPath(event.payload.link);
      if (path) {
        warmPrForOpen(queryClient, router, path, user);
      }
    };
    $[0] = queryClient;
    $[1] = router;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      eventKey: REALTIME_KEYS.DESKTOP_NOTIFICATION,
      id: t0,
      enabled: t1,
      onEvent: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useRealtime(t3);
  return null;
}